export default {
  typeName: {
    fontSize: 24,
  },
};
